import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Conditional } from '@resurs/react-utils'
import { getText } from '../TextLabels'

const isSilent = pathname =>
  pathname.includes('/apply') && !/^\/apply(|\/error)$/g.exec(pathname)

const VersionNotification = ({ newVersion, pathname, silent }) => (
  <Conditional when={newVersion}>
    <Conditional.Group>
      <Conditional
        when={pathname}
        anyOf={['/apply', '/transactions', '/login']}
        then={() => setTimeout(() => window.location.reload(), 0)}
      />
      <Conditional when={silent} then={() => null} />
      <Conditional.NoMatch>
        <div
          style={{
            position: 'fixed',
            bottom: '5rem',
            right: '5rem',
            background: '#ffdc75',
            border: '2rem solid #ffdc75',
            height: '20rem',
            boxShadow: '2px 2px 10px #aaa',
            fontFamily: 'monospace',
            zIndex: 9999,
          }}
        >
          <p style={{ marginBottom: '2rem' }}>
            {getText('default.newVersion')}
          </p>
          <a
            href="/"
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              window.location.reload()
            }}
          >
            {getText('default.reloadPage')}
          </a>
        </div>
      </Conditional.NoMatch>
    </Conditional.Group>
  </Conditional>
)

VersionNotification.propTypes = {
  newVersion: PropTypes.bool.isRequired,
  silent: PropTypes.bool.isRequired,
  pathname: PropTypes.string.isRequired,
}

export default connect(({ commons, router }) => ({
  newVersion: !!commons.appInfo.newVersion,
  pathname: router.location.pathname,
  silent: isSilent(router.location.pathname),
}))(VersionNotification)
